define(['jquery', 'jquery.history'], function ($) {
    var $flexgridTitles = $('.js-flexgrid-title');

    $(function () {
        History.pushState({}, document.title, window.location.href);
        updateTitleHeights();
    }());

    $(window).on('resize', function () {
        updateTitleHeights();
    })

    function updateTitleHeights() {
        if ($(this).width() > 1200) {
            for (var i = 0; i < $flexgridTitles.length; i++) {
                if ($flexgridTitles[i + 1]) {
                    $($flexgridTitles[i]).css('height', 'auto');
                    $($flexgridTitles[i + 1]).css('height', 'auto');

                    if ($($flexgridTitles[i]).outerHeight() > $($flexgridTitles[i + 1]).outerHeight()) {
                        $($flexgridTitles[i + 1]).css('height', $($flexgridTitles[i]).outerHeight());
                    } else {
                        $($flexgridTitles[i]).css('height', $($flexgridTitles[i + 1]).outerHeight());
                    }
                    i = i + 1;
                }
            }
        } else {
            for (var i = 0; i < $flexgridTitles.length; i++) {
                $($flexgridTitles[i]).css('height', 'auto');
            }
        }
    }

    $('.js-landing-search__input').on('keypress', function (e) {
        if (e.which == 13) { redirectToSearch($(this).val()); }
    });

    $('.js-landing-search__button').on('click', function (e) {
        var keyword = $(this).parent().find('.js-landing-search__input.search-input-large').val();
        if (!keyword) {
            keyword = $(this).parent().find('.js-landing-search__input.search-input-small').val();
        }
        if (keyword) {
            redirectToSearch(keyword);
        }
    });

    function redirectToSearch(keyword) {
        var url = window.location.href + '/search?keyword=' + encodeURIComponent(keyword);
        History.pushState({}, document.title, url);
        window.location.replace(url);
    }
});